export default {
    name: "DeleteData",
    title: "Delete Data",
    icon: "mdi-database-remove",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            table: null,
            idValue: null,
            childAction1: [],
            childAction2: []
        };
    },
};